const Mine = 449404040;

export {Mine};
if(process.env.NODE_ENV == 'development'){  
  console.log("Loaded my_pack");
}
